import {
  FiltersFieldNames,
  IFilterFieldConfig,
  IFilterValues,
  IGetFilterFieldConfig,
} from "../../types";
import { facetToCheckboxOption } from "../../../../Functional/converters/facetConverter";
import { IFacet } from "shared-services";
import { getAgencies } from "./getAgencies";
import { getCheckboxGroupComponents } from "../GenericFields/CheckboxTypeFilters/getCheckboxGroupComponents";

export const agentsFilterConfig: IFilterFieldConfig<IFilterValues> = {
  name: FiltersFieldNames.Agents,
  defaultValue: {},
  requestDataFunc: getAgencies,
  getFilterFiledProps: ({
    name,
    values,
    filterDrawerValues,
    setFilterValues,
    setFilterDrawerValues,
    filterData,
    t,
    dataTestId,
  }: IGetFilterFieldConfig<IFilterValues>) => {
    const agenciesData = (filterData[name] as IFacet[]) || [];

    if (Number(agenciesData?.length) <= 1) return;

    const fieldOptions = agenciesData.map(facetToCheckboxOption);

    const { filterControlComponent, filterDrawerConfig, tags } =
      getCheckboxGroupComponents({
        name,
        values,
        filterDrawerValues,
        fieldOptions,
        setFilterValues,
        setFilterDrawerValues,
        dataTestId,
        t,
      });

    return {
      tags,
      filterDrawerConfig,
      filterControlComponent,
    };
  },
};

export const agentsFilterConfigNoShowAsFilterControl = {
  ...agentsFilterConfig,
  modifiers: { showFilterControl: false },
};
